import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './modal-window.style';
import React, { Component } from 'react';
import ModalWindow from './modal-window';

export class ConfirmModalWindow extends Component {

  render() {
    const { show, onClose, title, children, css, contentId, modalId } = this.props;

    return (
      <ModalWindow
        modalId={modalId}
        contentId={contentId}
        show={show}
        onClose={e => onClose(e, false)}
        title={title}
        css={css}
        footer={(
          <div>
            <div>
              <button
                id='confirm'
                className='btn btn-primary'
                onClick={e => onClose(e, true)}>
                Yes
              </button>
              <button
                id='cancel'
                className='btn btn-default'
                onClick={e => onClose(e, false)}>
                No
              </button>
            </div>
          </div>
        )}
        children={children}/>
    );
  }
}

ConfirmModalWindow.propTypes = {
  modalId: PropTypes.string,
  contentId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.any.isRequired,
  children: PropTypes.any,
}

export default styleable(defaultStyle) (ConfirmModalWindow);
